export default __webpack_public_path__ + "static/media/5.6c59b359.jpg";